import script from "./UpgradesUnavailable.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradesUnavailable.vue?vue&type=script&setup=true&lang=js"

import "./UpgradesUnavailable.vue?vue&type=style&index=0&id=585b8cba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585b8cba"]])

export default __exports__